import React, { useEffect, useState } from "react";
import EVENTS from "../data/events";

// Devuelve la proxima sede que aun no ha empezado. Cuando pasa la de CDMX,
// el contador salta solo a Guadalajara y despues a Monterrey.
const getNextEvent = (now) =>
    EVENTS
        .map((event) => ({ ...event, time: new Date(event.start).getTime() }))
        .filter((event) => event.time > now)
        .sort((a, b) => a.time - b.time)[0] || null;

const getRemaining = (target, now) => {
    const diff = Math.max(target - now, 0);
    return {
        dias: Math.floor(diff / 86400000),
        horas: Math.floor((diff / 3600000) % 24),
        minutos: Math.floor((diff / 60000) % 60),
        segundos: Math.floor((diff / 1000) % 60)
    };
};

const pad = (n) => String(n).padStart(2, '0');

function Countdown() {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const next = getNextEvent(now);

    // Todas las sedes ya ocurrieron: no renderiza nada en vez de mostrar
    // un contador en cero.
    if (!next) {
        return null;
    }

    const { dias, horas, minutos, segundos } = getRemaining(next.time, now);

    return (
        <div className="countdown">
            <p className="countdown__label">
                Faltan para <strong>{next.city}</strong>
            </p>
            <div className="countdown__boxes">
                {[
                    { value: dias, label: dias === 1 ? 'día' : 'días' },
                    { value: pad(horas), label: 'horas' },
                    { value: pad(minutos), label: 'min' },
                    { value: pad(segundos), label: 'seg' }
                ].map((unit) => (
                    <div className="countdown__box" key={unit.label}>
                        <span className="countdown__value">{unit.value}</span>
                        <span className="countdown__unit">{unit.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Countdown;
